<template>
  <div class="login-page">
    <div class="login-card">
      <div class="login-brand">
        <div class="brand-mark">舆</div>
        <div>
          <h1>舆情监测平台</h1>
          <p>登录后提交与查看本租户任务申请，审核由后台管理员处理</p>
        </div>
      </div>

      <el-form ref="formRef" :model="form" :rules="rules" label-width="0" @submit.native.prevent="submit">
        <el-form-item prop="phone">
          <el-input v-model="form.phone" prefix-icon="el-icon-mobile-phone" placeholder="手机号" maxlength="11" />
        </el-form-item>
        <el-form-item prop="code">
          <div class="sms-code-row">
            <el-input v-model="form.code" prefix-icon="el-icon-key" placeholder="短信验证码" maxlength="6" @keyup.enter.native="submit" />
            <el-button :loading="codeSending" :disabled="countdown > 0" @click="sendCode">
              {{ countdown > 0 ? `${countdown}s` : '获取验证码' }}
            </el-button>
          </div>
        </el-form-item>
        <el-button type="primary" class="login-btn" :loading="loading" @click="submit">登录</el-button>
      </el-form>

    </div>

    <el-dialog
      title="安全校验"
      :visible.sync="captchaDialogVisible"
      width="360px"
      append-to-body
      @closed="resetCaptchaDialog"
    >
      <p class="captcha-dialog-tip">请输入图片验证码，校验通过后将生成短信验证码。</p>
      <el-form ref="captchaFormRef" :model="captchaForm" :rules="captchaRules" label-width="0" @submit.native.prevent="confirmSendCode">
        <el-form-item prop="captchaCode">
          <div class="captcha-row">
            <el-input
              v-model="captchaForm.captchaCode"
              prefix-icon="el-icon-picture-outline"
              placeholder="图片验证码"
              maxlength="4"
            />
            <img
              v-if="captchaImage"
              class="captcha-image"
              :src="captchaImage"
              alt="图片验证码"
              title="点击刷新"
              @click="loadCaptcha"
            />
            <el-button v-else :loading="captchaLoading" @click="loadCaptcha">加载</el-button>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="captchaDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="codeSending" @click="confirmSendCode">确认发送</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getCaptcha, login, sendSmsCode } from './api'

export default {
  name: 'LoginPage',
  data() {
    return {
      loading: false,
      codeSending: false,
      countdown: 0,
      countdownTimer: null,
      captchaDialogVisible: false,
      captchaImage: '',
      captchaId: '',
      captchaLoading: false,
      form: {
        phone: '',
        code: ''
      },
      captchaForm: {
        captchaCode: ''
      },
      rules: {
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { pattern: /^\d{6}$/, message: '验证码为6位数字', trigger: 'blur' }
        ]
      },
      captchaRules: {
        captchaCode: [
          { required: true, message: '请输入图片验证码', trigger: 'blur' },
          { pattern: /^[0-9a-zA-Z]{4}$/, message: '图片验证码为4位字符', trigger: 'blur' }
        ]
      }
    }
  },
  beforeDestroy() {
    this.clearCountdown()
  },
  methods: {
    async loadCaptcha() {
      this.captchaLoading = true
      try {
        const captcha = await getCaptcha()
        this.captchaId = captcha.captchaId
        this.captchaImage = captcha.imageBase64
        this.captchaForm.captchaCode = ''
      } catch (error) {
        this.$message.error((error && error.message) || '图片验证码加载失败')
      } finally {
        this.captchaLoading = false
      }
    },
    sendCode() {
      this.$refs.formRef.validateField('phone', async error => {
        if (error) return
        this.captchaDialogVisible = true
        await this.loadCaptcha()
        this.$nextTick(() => {
          if (this.$refs.captchaFormRef) {
            this.$refs.captchaFormRef.clearValidate()
          }
        })
      })
    },
    confirmSendCode() {
      if (this.codeSending) return
      this.codeSending = true
      this.$refs.captchaFormRef.validate(async valid => {
        if (!valid) {
          this.codeSending = false
          return
        }
        try {
          await sendSmsCode({
            phone: this.form.phone.trim(),
            captchaId: this.captchaId,
            captchaCode: this.captchaForm.captchaCode.trim()
          })
          this.$message.success('验证码已发送')
          this.captchaDialogVisible = false
          this.startCountdown()
        } catch (error) {
          this.$message.error((error && error.message) || '验证码发送失败')
          this.loadCaptcha()
        } finally {
          this.codeSending = false
        }
      })
    },
    resetCaptchaDialog() {
      this.captchaId = ''
      this.captchaImage = ''
      this.captchaForm.captchaCode = ''
    },
    submit() {
      this.$refs.formRef.validate(async valid => {
        if (!valid) return
        this.loading = true
        try {
          const session = await login({
            phone: this.form.phone.trim(),
            code: this.form.code.trim()
          })
          this.$emit('login', session)
        } catch (error) {
          this.$message.error((error && error.message) || '登录失败')
        } finally {
          this.loading = false
        }
      })
    },
    startCountdown() {
      this.clearCountdown()
      this.countdown = 60
      this.countdownTimer = setInterval(() => {
        this.countdown -= 1
        if (this.countdown <= 0) {
          this.clearCountdown()
        }
      }, 1000)
    },
    clearCountdown() {
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer)
        this.countdownTimer = null
      }
      if (this.countdown < 0) {
        this.countdown = 0
      }
    }
  }
}
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #eff6ff 0%, #f8fafc 45%, #eef2ff 100%);
  padding: 24px;
}

.login-card {
  width: 420px;
  max-width: 100%;
  background: #fff;
  border-radius: 16px;
  padding: 32px 28px 24px;
  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.08);
}

.login-brand {
  display: flex;
  gap: 14px;
  align-items: center;
  margin-bottom: 28px;
}

.brand-mark {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: linear-gradient(135deg, #2563eb, #1d4ed8);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  font-weight: 700;
}

.login-brand h1 {
  margin: 0 0 4px;
  font-size: 22px;
  color: #0f172a;
}

.login-brand p {
  margin: 0;
  font-size: 13px;
  color: #64748b;
}

.login-btn {
  width: 100%;
  margin-top: 4px;
}

.sms-code-row {
  display: grid;
  grid-template-columns: 1fr 116px;
  gap: 10px;
}

.captcha-row {
  display: grid;
  grid-template-columns: 1fr 120px;
  gap: 10px;
  align-items: center;
}

.captcha-image {
  width: 120px;
  height: 44px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  cursor: pointer;
  object-fit: cover;
}

.captcha-dialog-tip {
  margin: -4px 0 14px;
  font-size: 13px;
  color: #64748b;
}

</style>
